<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title" v-text="title"></div>
        <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button"
            style="width: 85px;margin-bottom: 3px"
        />
        <div class="f-grid-ind">
          <div class="f-grid-col-ind" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
            <div class="ind-text">Công ty</div>
            <div class="idn-sel">
              <DropdownScrollable placeholder="Chọn công ty" :limit="company_obj.limit" :loading="company_obj.loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="company_obj.items" :total="company_obj.total" @keyup="emitEvent" @offset="changeOffset" :showClear="true"/>
            </div>
          </div>
          <div class="f-grid-col-ind">
            <div class="ind-text">Khu vực</div>
            <div class="idn-sel">
              <DropdownScrollable placeholder="Chọn" :limit="areas_obj.limit" :loading="areas_obj.loading" v-model="areas" :options="areas_obj.items" :total="areas_obj.total" @keyup="emitEventAreas" @offset="changeOffsetAreas" :showClear="true"/>
            </div>
          </div>
          <div class="f-grid-col-ind">
            <div class="ind-text">Bộ phận</div>
            <div class="idn-sel">
              <DropdownScrollable placeholder="Chọn" :limit="department_obj.limit" :loading="department_obj.loading" v-model="department" :options="department_obj.items" :total="department_obj.total" @keyup="emitEventAreas" @offset="changeOffsetAreas" :showClear="true"/>
            </div>
          </div>
          <div class="f-grid-col-ind">
            <div class="ind-text">Công việc</div>
            <div class="idn-sel">
              <DropdownScrollable placeholder="Chọn" :limit="work_obj.limit" :loading="work_obj.loading" v-model="work" :options="work_obj.items" :total="work_obj.total" @keyup="emitEventWork" @offset="changeOffsetWork" :showClear="true"/>
            </div>
          </div>
        </div>
        <BaseDatatable
          :key="componentKey"
          :tableData="listData"
          :model.sync="dataModel"
          :options="options"
          :filterDefault="filters"
          :getFilterOptions="getFilterOptions"
          :actions="getRowActions()"
          v-on:action-click="onActionClicked"
          @onDataChange = 'DataOnChange'
          :company="company"
          :areas="areas"
          :department="department"
          :work="work"
          :evaluation_form_danger_id="evaluation_form_danger_id"
          :evaluation_form_id="evaluation_form_id"
          @showPopup="showPopup"
          @onEventOptions="onEventOptions"
          :company_id="company?.id"
        ></BaseDatatable>
        <Dialog
          style=""
          header="Xóa"
          :visible.sync="showDeleteDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          Bạn có chắc chắn muốn xoá biện pháp kiểm soát này khỏi danh sách?
          <template
            #footer
          >
          <Button
          label="Hủy"
          @click="showDeleteDialog = false"
          icon="pi pi-times"
          class="p-button-warning callback-btn"
          />
          <Button label="Xóa" @click="deleteData()" icon="pi pi-check" class="p-button-danger" />
          </template>
        </Dialog>
        <Dialog
          style=""
          header="Chi tiết đánh giá rủi ro"
          :visible.sync="showDetailDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          <table style="width:360px">
            <tr>
              <th style="width: 20%;">Tiêu chí</th>
              <th style="width: 20%;">Điểm</th>
              <th>Mức độ</th>
            </tr>
            <tr v-for="(item, index) in data_popup.list" :key="index">
              <td style="vertical-align: top;">{{item.code}}</td>
              <td style="vertical-align: top;">{{item.point}}</td>
              <td style="vertical-align: top;">{{item.name}}</td>
            </tr>
            <tr style="height: 34px;vertical-align: bottom;">
              <td>R</td>
              <td>{{data_popup.point}}</td>
              <td>{{data_popup.code}}</td>
            </tr>
          </table>
          <template
            #footer
          >
          <Button label="Đóng" icon="pi pi-check" class="p-button-success main-style-button"
            @click="showDetailDialog = false"
          />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import ApiRepository from "@/core/ApiRepository";
import BaseDatatable from './list'
import DropdownScrollable from '@/components/DropdownScrollable.vue';
export default {
  components: {
    BaseDatatable,
    DropdownScrollable
  },
  data() {
    return {
      filters : {},
      filterOptions: {},
      options: [],
      listData: [],
      modelName: '',
      dataModel: null,
      title: null,
      componentKey: 0,
      page_transaction:null,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      dataDelete :{},
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      company: {},
      company_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      popupWarning: false,
      areas : {},
      areas_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      department : {},
      department_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      work : {},
      work_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      evaluation_form_danger_id : null,
      evaluation_form_id : null,
      data_popup :{
        list : [],
        point : null,
        code :""
      },
      showDetailDialog : false,
      category_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      category : {},
      is_load : false
    }
  },
  async created() {
    this.options["category"] = {
      offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
    };
    this.is_load = true
    // this.filters = {
    //   evaluation_from_name : 'CV 1 -PDG 1',
    //   situation_name: 'CV 1 - TH 3'
    // }
    await this.initParams();
    await this.getListCompany()
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel(this.modelName);
    console.log('this.dataModel:',this.dataModel);
    // this.title = this.dataModel.name
    this.$store.commit('setLoading', true);
    if(this.$route.params.reload) {
      window.location.reload();
    }
    if (!this.$commonFuction.isEmpty(this.$route.query)){
        if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
          this.company = {id: this.$route.query.company_id};
          // setTimeout(() => {
          //     const query = Object.assign({}, this.$route.query);
          //     // delete query.company_id;
          //     this.$router.replace({ query });
          // }, 100);
        }
        
        if (!this.$commonFuction.isEmpty(this.$route.query.ef_id)){
            this.evaluation_form_id = this.$route.query.ef_id;
            // setTimeout(() => {
            //     const query = Object.assign({}, this.$route.query);
            //     this.$router.replace({ query });
            // }, 100);
        }
          
    }
    this.is_load = false
    // var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_BANNER);
    // if (arr_role.indexOf(this.$constants.ROLE.VIEW) < 0){
    //   this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
    // }
    // this.role.add = (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) ? false:true;
    // this.role.edit = (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) ? false:true;
    // this.role.delete = (arr_role.indexOf(this.$constants.ROLE.DELETE) < 0) ? false:true;
  },
  watch: {
    '$route': 'initParams',
    async 'company'() {
      this.getListCategory();
      if (!this.$commonFuction.isEmpty(this.$route.query.efd_id)){
          //gọi detail phiếu
          this.evaluation_form_danger_id = this.$route.query.efd_id;
          await this.defaultFilter()
          // setTimeout(() => {
          //     const query = Object.assign({}, this.$route.query);
          //     delete query.efd_id;
          //     this.$router.replace({ query });
          // }, 300);
      }
      this.componentKey++;
      this.clearAreas()
      this.clearDepartment()
      this.getListAreas()
      this.getListDepartment()
    },
    async 'areas'(){
      if(this.is_load == false){
        this.componentKey++;
      }
    },
    async 'department'(){
      if(this.is_load == false){
        this.clearWork()
      //   this.getListWork()
        // this.componentKey++;
      }
    },
    async 'work'(){
      if(this.is_load == false){
        this.componentKey++;
      }
    },
  },
  methods: {
    backToList() {
      this.$router.back();
    },
    emitEvent(keyword) {
      this.$delete(this.company_obj.filters, 'name');
      if (keyword) {
        this.company_obj.filters.name = keyword;
      }
      this.getListCompany();
    },
    changeOffset(value) {
      this.company_obj.offset = value;
      // this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.company_obj.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.company_obj.filters, limit: this.company_obj.limit, offset: this.company_obj.offset}, {headers}).then((res) => {
          if (this.company_obj.offset > 0 ) {
            this.company_obj.items.push(...res.data.data.company);
          } else{
            this.company_obj.items = res.data.data.company;
          }
          this.company_objs = res.data.data.company
          this.company_obj.total = res.data.data.total;
          this.company_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.company_obj.loading = false;
        })
      }
    },
    async initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      await this.$set(this, 'title', this.dataModel.label);
      // this.callbackOptions();
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    DataOnChange(data,f){
      if(f.type == 'Checkbox'){
      //   let dataUpdate = {}
      //   if(f.key == 'active'){
      //     dataUpdate['active'] = data[f.key]
      //   }
      //   let variables = {
      //     'data_update': dataUpdate,
      //     'where_key': {
      //       'id': {'_eq': data.id}
      //     }
      //   };
      //   this.$apollo.mutate({
      //     mutation: DataServices.updateData(this.modelName),
      //     variables: variables
      //   }).then(() => {})
      }
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      // console.log("field",field)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      // console.log("result",result)
      return result;
    },
    getRowActions() {
      var actions = {}
    //   var that = this;
      actions.rows = function () {
        var buttons = {}
        return buttons
      }
      return actions
    },
    async callbackOptions() {
      this.dataModel.getDisplayFields();
    },
    async onActionClicked(payload) {
      // console.log("payload==",payload)
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          alert("chưa phát triển")
          // this.dialogMode = action.name
          // if (action.path !== undefined && action.path) {
          //   this.$router.push({ path: action.path + data.data[action.key] })
          // } else  {
          //   this.editId = data.data[action.key]
          //   this.displayDialog = true
          //   this.editDialogKey++
          // }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString(), company_id: this.company?.id }  })
          } else  {
            this.page_transaction = pageTransaction.toString();
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name_en
          this.dataDelete = data.data
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
        case 'evaluation':
          alert("chưa phát triển")
          // this.componentKey++
          break
        case 'history':
          alert("chưa phát triển")
          // this.componentKey++
          break
      }
    },
    async sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async deleteData() {
      this.showDeleteDialog = false
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/control_measures/delete", {control_measures_id: that.deleteId, company_id: that.company.id}, {headers}).then(function () {
          that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa thành công', life: 3000 })
          that.$commonFuction.is_loading(false);
          that.componentKey += 1;
        }).catch((err) => {
          that.$toast.add({
            severity: 'error',
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: err,
            life: 3000
          })
        })
      }
    },
    emitEventAreas(keyword) {
      // console.log(keyword);
      this.$delete(this.areas_obj.filters, 'name');
      if (keyword) {
        this.areas_obj.filters.name = keyword;
      }
      this.getListAreas();
    },
    changeOffsetAreas(value) {
      this.areas_obj.offset = value;
    },
    async getListAreas() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.areas_obj.loading = true;
        await ApiRepository.post("/_api/area/options", {filters: this.areas_obj.filters, limit: this.areas_obj.limit, offset: this.areas_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            if (this.areas_obj.offset > 0 ) {
              this.areas_obj.items.push(...res.data.data.area);
            } else{
              this.areas_obj.items = res.data.data.area;
            }
            this.areas_obj.total = res.data.data.count;
            this.areas_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.areas_obj.loading = false;
        })
      }
    },
    emitEventDepartment(keyword) {
      // console.log(keyword);
      this.$delete(this.department_obj.filters, 'name');
      if (keyword) {
        this.department_obj.filters.name = keyword;
      }
      this.getListDepartment();
    },
    changeOffsetDepartment(value) {
      this.department_obj.offset = value;
    },
    async getListDepartment() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      this.department_obj.filters.active = true;
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.department_obj.loading = true;
        await ApiRepository.post("/_api/department/options", {filters: this.department_obj.filters, limit: this.department_obj.limit, offset: this.department_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            if (this.department_obj.offset > 0 ) {
              this.department_obj.items.push(...res.data.data.department);
            } else{
              this.department_obj.items = res.data.data.department;
            }
            this.department_obj.total = res.data.data.count;
            this.department_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.department_obj.loading = false;
        })
      }
    },
    emitEventWork(keyword) {
      // console.log(keyword);
      this.$delete(this.work_obj.filters, 'name');
      if (keyword) {
        this.work_obj.filters.name = keyword;
      }
      this.getListWork();
    },
    changeOffsetWork(value) {
      this.work_obj.offset = value;
    },
    async getListWork() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      this.$delete(this.work_obj.filters, 'department_id');
      if(!this.$commonFuction.isEmptyObject(this.department)){
        this.work_obj.filters.department_id = this.department.id
      }
      this.work_obj.filters.active = true
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        }
        this.work_obj.loading = true;
        await ApiRepository.post("/_api/work/options", {filters: this.work_obj.filters, limit: this.work_obj.limit, offset: this.work_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.work_obj.offset > 0 ) {
            this.work_obj.items.push(...res.data.data.list);
          } else{
            this.work_obj.items = res.data.data.list;
          }
          this.work_obj.total = res.data.data.total;
          this.work_obj.loading = false;
        }).catch((err) => {
          console.log(err);
          this.work_obj.loading = false;
        })
      }
    },
    clearAreas(){
      this.areas_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.areas = {}
    },
    clearWork(){
      this.work_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.work = {}
    },
    clearDepartment(){
      this.department_obj ={
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.department = {}
    },
    async showPopup(data){
      var id = data.id //lấy id của lịch sử
      this.$commonFuction.is_loading(true);
      if(id){
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
          const headers = {
            "Authorization": "Bearer "+token,
          };
          var that = this;
          await ApiRepository.post("/_api/evaluation_form_danger/risk_history", {id: id, company_id: that.company.id}, {headers}).then(function (response) {
            var resp = response.data.data;
            var tmp = []
            var code = ""
            var total = null
            if(data.status == 'APPROVE' || data.status =='COMPLETE'){
              for (let i = 0; i < resp.risk_assessment_ra.length; i++) {
                let e = resp.risk_assessment_ra[i];
                let name = ''
                if(e.criteria_json && e.criteria_json.level){
                  name = e.criteria_json.level.name ?? ''
                }
                tmp.push({
                    code : e.criteria_json?.code,
                    point : that.formatNumber(e.point,0),
                    name : name,
                })
              }
            }else{
              for (let i = 0; i < resp.risk_assessment.length; i++) {
                let e = resp.risk_assessment[i];
                let name = ''
                if(e.criteria_json && e.criteria_json.level){
                  name = e.criteria_json.level.name ?? ''
                }
                tmp.push({
                    code : e.criteria_json?.code,
                    point : that.formatNumber(e.point,0),
                    name : name,
                })
              }
            }
            code = data.code
            total = that.formatNumber(data.point,0)
            
            that.data_popup = {
              list : tmp,
              point : total,
              code : code
            }
            that.showDetailDialog = true;
            that.$commonFuction.is_loading(false);
            // console.log("datadata=",that.data_popup)
          }).catch((err) => {
            that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
            })
          })
        }
      }
      this.$commonFuction.is_loading(false);
    },
    formatNumber(value,decimals=2){
      const digitsRE = /(\d{3})(?=\d)/g
      value = parseFloat(value)
      if (!isFinite(value) || (!value && value !== 0)) return ''
      decimals = decimals != null ? decimals : 2
      var stringified = Math.abs(value).toFixed(decimals)
      var _int = decimals
        ? stringified.slice(0, -1 - decimals)
        : stringified
      var i = _int.length % 3
      var head = i > 0
        ? (_int.slice(0, i) + (_int.length > 3 ? '.' : ''))
        : ''
      var _float = decimals
        ? stringified.slice(-1 - decimals)
        : ''
      var sign = value < 0 ? '-' : '';
      var text = sign + head +
        _int.slice(i).replace(digitsRE, '$1.') +
        _float
      return text
    },
    async onEventOptions({event, key, data}) {
      console.log(key);
      if (key == "category") {
        this.category = data;
        if (event == 'offset') {
          await this.getListCategory();
        }
      }
    },
    async getListCategory() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.options["category"] = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        };
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.category_obj.loading = true;

        await ApiRepository.post("/_api/category/options", {filters: this.category_obj.filters, limit: this.category_obj.limit, offset: this.category_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.category_obj.offset > 0 ) {
            this.category_obj.items.push(...res.data.data.list);
          } else{
            this.category_obj.items = res.data.data.list;
          }
          this.category_obj.total = res.data.data.total;
          this.category_obj.loading = false;
          this.options["category"] = this.category_obj;
        }).catch((err) => {
            console.log(err);
            this.category_obj.loading = false;
        })
      }
    },
    async defaultFilter() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        var object = {
          id : this.evaluation_form_danger_id,
          company_id: this.company.id
        }
        var data = null
        await ApiRepository.post("/_api/evaluation_form_danger/detail_normal", object, {headers}).then(async (res) => {
          data = res.data.data
        })
        // console.log("data===",data)

        if(data){
          var evaluation_form_name = data.evaluation_form.name
          var situation_name = ''
          var danger_name = ''
          if(data.situation && data.situation.type == 'other'){
            situation_name = data.other_situation_name
          }else{
            situation_name = data.situation.name
          }
          if(data.danger && data.danger.type == 'other'){
            danger_name = data.other_danger_name
          }else{
            danger_name = data.danger.name
          }
          var obj = {
            evaluation_from_name : evaluation_form_name,
            situation_name: situation_name,
            danger_name : danger_name,
          }
          console.log("obj==",obj)
          this.filters =obj
        }
      }
      // this.componentKey++;
    },
  },
}
</script>
<style lang="css">
.p-calendar .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
.p-button-warning-o .p-button-label-o{
  color: #e95d57;
}
.p-button-warning .pi-times{
  color: #e95d57;
}
.f-grid-ind {
  display: flex;
  margin-left: -1rem;
  flex-flow: row wrap;
}

.f-grid-col-ind {
  width: 25% !important;
  padding: 0rem 0rem 0rem 1rem;
}
.ind-text { 
  font-weight: 600;
}
.idn-sel {
  margin-top: -6px;
}
</style>